/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import Description from "App/model/description";
import {RenderElement} from "App/model/elements/element";
import {Factory} from "App/model/elements/factory";

export default
class RenderElements {

    private _modelDescription: Description;
    private _elements: any = {};
    private _parsedElementUIDToElementMapping: any = {};

    constructor(aModelDescription: Description) {
        this._modelDescription = aModelDescription;
    }

    public addElement(aElementTypeName: string, aElementDescriptionJSON: any): RenderElement {
        let element = Factory.create(aElementTypeName, this._modelDescription);
        element.parse(aElementDescriptionJSON);
        this._elements[element.getUID()] = element;
        this._parsedElementUIDToElementMapping[element.getParsedUID()] = element;

        return element;
    }

    public removeElement(aModelElement: RenderElement) {
        if (this._elements[aModelElement.getUID()] !== undefined) {
            delete this._elements[aModelElement.getUID()];
        }

        if (this._parsedElementUIDToElementMapping[aModelElement.getParsedUID()] !== undefined) {
            delete this._parsedElementUIDToElementMapping[aModelElement.getParsedUID()];
        }
    }

    public getElementsByType(aElementType: string): RenderElement[] {
        let searchResult: RenderElement[] = [];
        for (let key in this._elements) {
            let element = this._elements[key];
            if (element.getType() === aElementType) {
                searchResult.push(element);
            }
        }

        return searchResult;
    }

    public getElementByParsedUID(aParsedUID: number): RenderElement {
        let element = this._parsedElementUIDToElementMapping[aParsedUID];
        if (element === undefined) {
            return null;
        }

        return element;
    }

    public parse(aModelDescriptionJSON: any): boolean {
        if (!aModelDescriptionJSON.hasOwnProperty("Elements")) {
            return false;
        }

        let elementsJSON = aModelDescriptionJSON.Elements;

        // pass through all elements
        for (let i = 0; i < elementsJSON.length; i++) {
            let elementJSON = elementsJSON[i];

            if (!elementJSON.hasOwnProperty("type")) {
                return false;
            }

            // TODO: move this code to some compatibility solver class
            // convert Poi to GeometryEntity
            if (elementJSON.type === "Poi") {
                elementJSON.type = "GeometryEntity";
                elementJSON.entities = elementJSON.pois;

                // correct the Poi type to PoiEntity type
                for (let j = 0; j < elementJSON.entities.length; j++) {
                    elementJSON.entities[j].type = "PoiEntity";
                }
            }
            this.addElement(elementJSON.type, elementsJSON[i]);
        }

        return true;
    }

    public getJSONRepresentation(): any {
        let elements = [];

        for (let key in this._elements) {
            let element = this._elements[key];
            elements.push(element.getJSONRepresentation());
        }

        return elements;
    }

    public getElementsByAnnotations(aAnnotationsIdArray: number[]): RenderElement[] {
        let elements = [];
        // for (let key in this._elements) {
        //     let element = this._elements[key];
        //     if (element._annotations[])
        //
        // }
        return elements;
    }
}
